import _ from "lodash";

export function getAuthorPropertiesObject(entity) {
	if (!entity || !entity.authorProperties) {
		return {};
	}
	if (_.isObject(entity.authorProperties)) {
		return entity.authorProperties;
	}
	if (_.isString(entity.authorProperties)) {
		try {
			const parsed = JSON.parse(entity.authorProperties);
			return _.isObject(parsed) ? parsed : {};
		} catch (err) {
			return {};
		}
	}
	return {};
}

export function hasBankRefReference(entity) {
	const authorProperties = getAuthorPropertiesObject(entity);
	const bankRef = _.get(authorProperties, "bankRef");
	return _.isObject(bankRef) && !_.isEmpty(bankRef);
}

export function hasBankRefDraftSource(entity) {
	const authorProperties = getAuthorPropertiesObject(entity);
	const draftSource = _.get(authorProperties, "bankRefDraftSource");
	return _.isObject(draftSource) && !_.isEmpty(draftSource);
}
